(function() {
    /*'use strict';*/

    //Globals
    var $trigger = $('.nav--primary__icon'),
        $nav = $('.nav--primary__panel'),
        $overlay = $('<div gr-nav-overlay class="gr-overlay"/>');

    $overlay.appendTo('body');

    function _toggleClass() {
        $nav.toggleClass('is-open');
        $trigger.toggleClass('is-active');
        $overlay.toggleClass('is-visible');
        $('html').toggleClass('has-nav-open');
    }

    $trigger.on('click', function(event) {
        event.preventDefault();
        _toggleClass();
    });

    $overlay.on('click', function(event) {
        event.preventDefault();
        _toggleClass();
    });

    $(document).keyup(function(event) {
        if (event.keyCode == 27 && $nav.hasClass('is-open')) {
            _toggleClass();
        }
    });

    NodeList.prototype.toArray = function() {
        return Array.prototype.slice.call(this);
    };

    FileList.prototype.toArray = function() {
        return Array.prototype.slice.call(this);
    };

    $(document).on('ready domloaded ajaxloaded', function () {
        // partners page uploader
        if (util.id('uploader')) {
            Uploader.init();
        }

        // home page tabs
        if (util.id('brands')) {
            Banner.init();
        }

        // home / partners table toggables
        if (util.id('results__table')) {
            Tables.init({
                actionBtnSelector: '.b-btn--download[type="submit"]',
                checkboxAllSelector: '#checkbox-select-all',
                checkboxSelector: '.checkbox-select'
            });

            Toggables.init({
                closeAllOnToggle: true,
                onToggled: function onToggled(trigger, trget) {
                    trget.style.height = trget.scrollHeight + 'px';
                    trget.parentNode.style.marginBottom = trget.scrollHeight + 'px';
                },
                offToggled: function offToggled(trigger, trget) {
                    trget.style.height = 0;
                    trget.parentNode.style.marginBottom = 0;
                }
            });
        }

        if (util.id('login')) {
            Login.init();
        }

        //paginate
        if (util.id('paginate-list')) {
            Paginate.init();
        }
    });

})();



window.emulateObjectfit = function (node) {
    // restrict to valid object-fit value
    var objectFit = node.currentStyle['object-fit'];

    if (!objectFit || !/^(contain|cover|fill)$/.test(objectFit)) return;

    var addEventListener = node.addEventListener || node.attachEvent;
    var removeEventListener = node.removeEventListener || node.detachEvent;
    var on = node.addEventListener ? '' : 'on';
    var img = node.nodeName.toLowerCase() === 'img';
    var type = img ? 'load' : 'loadedmetadata';

    addEventListener.call(node, on + type, onload);

    if (node.complete) onload();

    function onload() {
        removeEventListener.call(node, on + type, onload);
        var imgx = document.createElement('objectfit');
        imgx.appendChild(node.parentNode.replaceChild(imgx, node));
        imgx.style.backgroundImage = 'url('+ node.src +')';
    }
};

window.emulateObjectfit.init = function () {
    if (document.body) {
        var all = document.querySelectorAll('img,video');
        var index = -1;

        while (all[++index]) window.emulateObjectfit(all[index]);
    } else {
        setTimeout(window.emulateObjectfit.init);
    }
};

if (/MSIE|Trident/.test(navigator.userAgent)) {
    window.emulateObjectfit.init();
}
